<agr-table [config]="tableConfig" [enableStepArrows]="false"> </agr-table>
<ng-template #productNameTemplate let-row="row">
  <mat-select
    [hideSingleSelectionIndicator]="true"
    class="flex__child--auto spacing--margin-right text--small"
    panelClass="mat-select-product-panel"
    [value]="getProduct(row, products)"
    [compareWith]="areProductsEqual"
    placeholder="< product >"
    (selectionChange)="selectProduct($event, row)"
    data-test="product-column"
    [ngClass]="productError && !row.product ? 'validation-error' : ''"
  >
    <mat-option *ngFor="let product of products" [value]="product">
      {{ product.code }} - {{ product.name }}
    </mat-option>
  </mat-select>
</ng-template>
<ng-template #feedAmountTemplate let-row="row" let-column="column">
  <span class="spacing--margin-left spacing--padding-right">{{ getValue(row[column.id]) }} </span>
</ng-template>
<ng-template #feedAmountAverageTemplate let-row="row" let-column="column">
  <div class="average">
    <span class="spacing--margin-left spacing--padding-right">{{ getValue(row[column.id]) }} </span>
  </div>
</ng-template>
